import { EditableContentTabs } from "@caelor/ui";
import styled from "styled-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePagesStore } from "../../../stores/use-page-store";

const Container = styled.div`
  display: grid;
  align-items: center;
  justify-items: flex-start;
  width: 100%;
`;

function EditingTabs() {
  const {
    data,
    selectedTab,
    setSelectedTab,
    updateTabs,
    updateConfig,
    createNewTab,
    deleteTab,
  } = usePagesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(true),
    setSelectedTab: state.setSelectedTab,
    updateTabs: state.updateTabs,
    updateConfig: state.updateConfig,
    createNewTab: state.createNewTab,
    deleteTab: state.deleteTab,
  }));

  const { t } = useTranslation();

  const { tabs, config } = data || {};

  if (!config?.showTabs) return <></>;

  return (
    <Container>
      <EditableContentTabs
        isEditable={true}
        tabs={tabs}
        value={selectedTab}
        setValue={(value) => {
          setSelectedTab(value.id);
        }}
        updateConfig={updateConfig}
        onCreate={() => createNewTab()}
        onChange={(value) => updateTabs(value)}
        onDelete={(value) => deleteTab(value)}
        i18n={t}
      />
    </Container>
  );
}

export default EditingTabs;
